export default __webpack_public_path__ + "static/strawberry-pointing-right-7ec03a954bd4490735518b14816290c9.svg";